module.exports = __webpack_public_path__ + "static/media/services.8f927dab.png";